import { IEngagementsOrdersByPeriodItem } from 'pages/Dashboard/Dashboard.models';

import {
  GET_ENGAGEMENTS_ORDERS_MRC_REQUEST,
  GET_ENGAGEMENTS_ORDERS_MRC_SUCCESS,
  GET_ENGAGEMENTS_ORDERS_MRC_FAILURE,
} from './actionsTypes';

interface IGetEngagementsOrdersMrcState {
  data: IEngagementsOrdersByPeriodItem[];
  isLoading: boolean;
  error: object;
}

const initialState: IGetEngagementsOrdersMrcState = {
  isLoading: false,
  data: [],
  error: {},
};

const getEngagementsOrdersMrcReducer = (state = initialState, {
  type, data, error,
}) => {
  if (type === GET_ENGAGEMENTS_ORDERS_MRC_REQUEST) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (type === GET_ENGAGEMENTS_ORDERS_MRC_SUCCESS) {
    return {
      ...state,
      data,
      isLoading: false,
    };
  }

  if (type === GET_ENGAGEMENTS_ORDERS_MRC_FAILURE) {
    return {
      ...state,
      isLoading: false,
      error,
      data: [],
    };
  }

  return state;
};
export default getEngagementsOrdersMrcReducer;
